const checkIsImage=(url)=>{
    const [, , , extension] = /([^.]+)(\.(\w+))?$/.exec(url);
    const imageExtensions = [".jpg", ".gif", ".png", ".jpeg", "tiff"];
    const isImage = imageExtensions.includes(`.${extension}`);
    return isImage;
};

export default checkIsImage;